<div
  class="towers-area--container"
  [class.towers-area--grid__medium]="
    towersService.mode().modeName === 'medium' ||
    towersService.mode().modeName === 'high'
  "
  [class.towers-area--grid__low]="towersService.mode().modeName === 'low'"
>
  @for (item of towersService.items(); track $index; let i = $index) {
  <app-towers-item
    (click)="towersService.selectTower(i)"
    [multiplier]="item.multiplier"
    [state]="item.state"
    [picked]="item.picked"
    [balance]="towersService.currentGame()?.balancetype!"
  ></app-towers-item>
  }
  <div class="towers-area--progress__grid towers-area--progress__left">
    @if (towersService.currentGame()) {
    <div
      #progressLeft
      [class.towers-area--progress__red]="
        towersService.currentGame()?.status === 'finished' &&
        !towersService.currentGame()?.won
      "
      [class.towers-area--progress__yellow]="
        towersService.currentGame()?.won ||
        towersService.currentGame()?.status !== 'finished'
      "
      [style.grid-row-start]="towersService.pickIndexes().length + 1"
    ></div>
    }
  </div>
  <div class="towers-area--progress__grid towers-area--progress__right">
    @if (towersService.currentGame()) {
    <div
      #progressRight
      class="transform-rotate-180"
      [class.towers-area--progress__red]="
        towersService.currentGame()?.status === 'finished' &&
        !towersService.currentGame()?.won
      "
      [class.towers-area--progress__yellow]="
        towersService.currentGame()?.won ||
        towersService.currentGame()?.status !== 'finished'
      "
      [style.grid-row-start]="towersService.pickIndexes().length + 1"
    ></div>
    }
  </div>
</div>
